import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.collab.drive');
import { OnInit, OnChanges, Input, SimpleChanges } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-collab-drive',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/portal.lpsysadmin.collab.drive/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PortalLpsysadminCollabDriveComponent implements OnInit, OnChanges {
    constructor(@Inject( Service) public service: Service) { }

    @Input() workspace_id: string = '';
    @Input() folder_id: string = '';

    public files: any[] = [];
    public breadcrumb: any[] = [];
    public me: string = '';
    public loaded: boolean = false;
    public showTrash: boolean = false;
    public search: string = '';
    public viewMode: 'grid' | 'list' = 'list';

    public showCreateFolder: boolean = false;
    public newFolderName: string = '';
    public renamingId: string = '';
    public renameValue: string = '';

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public async ngOnChanges(c: SimpleChanges) {
        if ((c['workspace_id'] && !c['workspace_id'].firstChange) ||
            (c['folder_id'] && !c['folder_id'].firstChange)) {
            await this.load();
        }
    }

    public async load() {
        const params: any = {};
        if (this.workspace_id) params.workspace_id = this.workspace_id;
        if (this.folder_id) params.parent_id = this.folder_id;
        if (this.showTrash) params.trash = '1';
        if (this.search) params.search = this.search;
        const res = await wiz.call("list", params);
        if (res.code === 200) {
            this.files = res.data.rows || [];
            this.breadcrumb = res.data.breadcrumb || [];
            this.me = res.data.me;
        }
        this.loaded = true;
        await this.service.render();
    }

    public goFolder(id: string) {
        const base = this.workspace_id
            ? `/admin/collab/drive/${this.workspace_id}`
            : `/admin/collab/drive`;
        const path = id ? `${base}/${id}` : base;
        this.service.href(path);
    }

    public goRoot() {
        this.goFolder('');
    }

    public openFile(f: any) {
        if (f.type === 'folder') {
            this.goFolder(f.id);
        } else {
            this.download(f);
        }
    }

    public download(f: any) {
        const url = `/wiz/api/portal.lpsysadmin.collab.drive/download?id=${encodeURIComponent(f.id)}`;
        window.open(url, '_blank');
    }

    public async createFolder() {
        if (!this.newFolderName.trim()) return;
        const params: any = { name: this.newFolderName.trim() };
        if (this.workspace_id) params.workspace_id = this.workspace_id;
        if (this.folder_id) params.parent_id = this.folder_id;
        const res = await wiz.call("create_folder", params);
        if (res.code === 200) {
            this.showCreateFolder = false;
            this.newFolderName = '';
            await this.load();
        } else {
            this.service.alert.error(res.data?.message || '생성 실패');
        }
    }

    public async onUpload(ev: any) {
        const file = ev.target.files?.[0];
        if (!file) return;
        const fd = new FormData();
        fd.append('file', file);
        if (this.workspace_id) fd.append('workspace_id', this.workspace_id);
        if (this.folder_id) fd.append('parent_id', this.folder_id);
        try {
            const r = await fetch('/wiz/api/portal.lpsysadmin.collab.drive/upload', {
                method: 'POST', body: fd,
            });
            if (r.ok) {
                ev.target.value = '';
                await this.load();
            } else {
                this.service.alert.error('업로드 실패');
            }
        } catch (e) {
            this.service.alert.error('업로드 오류');
        }
    }

    public startRename(f: any, ev?: Event) {
        if (ev) ev.stopPropagation();
        this.renamingId = f.id;
        this.renameValue = f.name;
    }

    public async submitRename(f: any) {
        if (!this.renameValue.trim() || this.renameValue === f.name) {
            this.renamingId = '';
            return;
        }
        const res = await wiz.call("rename", { id: f.id, name: this.renameValue.trim() });
        if (res.code === 200) {
            this.renamingId = '';
            await this.load();
        }
    }

    public async toTrash(f: any, ev?: Event) {
        if (ev) ev.stopPropagation();
        if (!confirm(`'${f.name}'을(를) 휴지통으로 이동하시겠습니까?`)) return;
        const res = await wiz.call("trash", { id: f.id });
        if (res.code === 200) await this.load();
    }

    public async restore(f: any, ev?: Event) {
        if (ev) ev.stopPropagation();
        const res = await wiz.call("restore", { id: f.id });
        if (res.code === 200) await this.load();
    }

    public async permaDelete(f: any, ev?: Event) {
        if (ev) ev.stopPropagation();
        if (!confirm(`'${f.name}'을(를) 영구 삭제하시겠습니까? 복구할 수 없습니다.`)) return;
        const res = await wiz.call("remove", { id: f.id });
        if (res.code === 200) await this.load();
    }

    public async toggleStar(f: any, ev?: Event) {
        if (ev) ev.stopPropagation();
        const res = await wiz.call("star", { id: f.id });
        if (res.code === 200) {
            f.is_starred = res.data.starred;
            await this.service.render();
        }
    }

    public async toggleTrash() {
        this.showTrash = !this.showTrash;
        await this.load();
    }

    public icon(f: any): string {
        if (f.type === 'folder') return 'fa-folder';
        const m = (f.mime || '').toLowerCase();
        if (m.startsWith('image/')) return 'fa-file-image';
        if (m.startsWith('video/')) return 'fa-file-video';
        if (m.startsWith('audio/')) return 'fa-file-audio';
        if (m.includes('pdf')) return 'fa-file-pdf';
        if (m.includes('zip') || m.includes('compress')) return 'fa-file-zipper';
        if (m.includes('word')) return 'fa-file-word';
        if (m.includes('excel') || m.includes('sheet')) return 'fa-file-excel';
        if (m.includes('text')) return 'fa-file-lines';
        return 'fa-file';
    }

    public iconColor(f: any): string {
        if (f.type === 'folder') return 'text-amber-500';
        const m = (f.mime || '').toLowerCase();
        if (m.startsWith('image/')) return 'text-emerald-500';
        if (m.includes('pdf')) return 'text-rose-500';
        if (m.includes('excel') || m.includes('sheet')) return 'text-emerald-600';
        if (m.includes('word')) return 'text-sky-600';
        return 'text-zinc-400';
    }

    public sizeStr(n: number): string {
        if (!n) return '';
        if (n < 1024) return `${n} B`;
        if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
        if (n < 1024 * 1024 * 1024) return `${(n / 1024 / 1024).toFixed(1)} MB`;
        return `${(n / 1024 / 1024 / 1024).toFixed(2)} GB`;
    }
}

export default PortalLpsysadminCollabDriveComponent;